export default __webpack_public_path__ + "static/media/cemredort4.7adf7596.jpg";